import React from 'react';
import { Navigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useUserRole } from '../hooks/useUserRole';
import { RBACOnboardingGuard } from './RBACOnboardingGuard';

interface AdminOnlyRouteProps {
  children: React.ReactNode;
}

const AdminOnlyRoute: React.FC<AdminOnlyRouteProps> = ({ children }) => {
  const { isAdmin, loading, errorCode } = useUserRole();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        color: '#666',
      }}>
        Loading...
      </div>
    );
  }

  if (errorCode === 'tenant_user_missing') {
    return <RBACOnboardingGuard errorCode={errorCode} onRetry={() => window.location.reload()} />;
  }

  if (!isAdmin) {
    toast.error('Access denied. Only administrators can access this area.');
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
};

export default AdminOnlyRoute;
